export default __webpack_public_path__ + "static/media/logo.0c793c5f.svg";